import _defineProperty from "/home/jenkins/agent/workspace/ite-static-site-generator_master/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
/** @clearscore/helpers.resolve-props v1.17.10: 2023-3-8 15:45 (assemble v5.5.3) **/
import _objectSpread from '@babel/runtime/helpers/objectSpread2';

/**
 * Given an single pathref, resolve to the value of the given data object
 * @param {string} pathArr single property path
 * @param {object} obj object of data to resolve
 * @returns {object} object containing resolved data
 */
function resolveProp(pathArr, obj) {
  if (arguments.length === 1) {
    return function (objHolder) {
      return resolveProp(pathArr, objHolder);
    };
  }
  if (obj === null || obj === undefined) {
    return undefined;
  }
  var willReturn = obj;
  var counter = 0;
  var pathArrValue = typeof pathArr === 'string' ? pathArr.split('.') : pathArr;
  while (counter < pathArrValue.length) {
    if (willReturn === null || willReturn === undefined) {
      return undefined;
    }
    willReturn = willReturn[pathArrValue[counter]];
    counter += 1;
  }
  return willReturn;
}
/**
 * Given an object of object property paths and an object, resolves the paths to the values in the object
 * @param {object} paths object of property paths
 * @param {object} data object of data to resolve
 * @returns {object} object containing resolved data
 */

function resolveProps(paths, data) {
  return Object.keys(paths).reduce(function (resolvedData, prop) {
    var pathRef = paths[prop];
    return _objectSpread(_objectSpread({}, resolvedData), {}, _defineProperty({}, prop, resolveProp(pathRef, data)));
  }, {});
}
export { resolveProps as default, resolveProp };